(() => {
  const key = 'patina-circle-info-seen-v1';
  const week = 7 * 24 * 60 * 60 * 1000;
  function init() {
    const root = document.querySelector('[data-pc-root]');
    if (!root || root.dataset.pcReady) return;
    root.dataset.pcReady = 'true';
    const dialog = root.querySelector('dialog');
    const launcher = root.querySelector('[data-pc-open]');
    if (!dialog || typeof dialog.showModal !== 'function') {
      if (launcher) launcher.hidden = true;
      return;
    }
    let previousFocus = null;
    let timer;
    function markSeen() {
      try { localStorage.setItem(key, String(Date.now())); } catch {}
    }
    function eligible() {
      if (root.dataset.pcActive !== 'true' || root.dataset.pcAuto !== 'true' || root.dataset.pcSignedIn === 'true' || root.dataset.pcDesignMode === 'true') return false;
      if (/\/pages\/patina-circle\/?$/.test(location.pathname) || location.hash.startsWith('#ba-')) return false;
      try { const seen = Number(localStorage.getItem(key)); return !seen || Date.now() - seen > week; } catch { return false; }
    }
    function show(manual) {
      if (dialog.open) return;
      if (!manual) {
        if (!eligible() || document.hidden || document.querySelector('dialog[open], [aria-modal="true"]') || document.activeElement?.matches('input,textarea,select,[contenteditable="true"]')) return;
        const privacy = window.Shopify?.customerPrivacy;
        if (privacy?.shouldShowBanner?.()) return;
      }
      previousFocus = document.activeElement;
      dialog.showModal();
      document.documentElement.classList.add('pc-dialog-open');
      dialog.querySelector('[data-pc-close]').focus();
      markSeen();
    }
    function close() { if (dialog.open) dialog.close(); }
    launcher?.addEventListener('click', () => { clearTimeout(timer); show(true); });
    root.querySelectorAll('[data-pc-close]').forEach(el => el.addEventListener('click', close));
    root.querySelectorAll('[data-pc-action]').forEach(el => el.addEventListener('click', close));
    dialog.addEventListener('click', e => { if (e.target !== dialog) return; const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close(); });
    dialog.addEventListener('close', () => { document.documentElement.classList.remove('pc-dialog-open'); markSeen(); if (previousFocus?.isConnected) previousFocus.focus(); });
    if (eligible()) timer = setTimeout(() => show(false), Math.max(8, Number(root.dataset.pcDelay) || 18) * 1000);
    document.addEventListener('shopify:section:unload', () => { clearTimeout(timer); close(); }, {once:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();
